<template>
    <div>
        <v-card flat class="pa-1">
            <v-toolbar flat color="#FFF" short>
                <v-toolbar-title>Listagem de Tipos de Eventos</v-toolbar-title>
            </v-toolbar>
            <v-tabs centered>
                <v-tab>
                    <v-icon left>mdi-format-list-text</v-icon>
                    Tipos de Evento 
                </v-tab>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            
                            <v-data-table
                                    :headers="headers"
                                    :items="desserts"
                                    :height="320"
                                    :fixed-header="true"
                                    class="elevation-3"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Cadastro de Tipos de Evento</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical/>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" dark class="mb-2" @click="dialogCadastro=true;editedIndex=-1;">Novo</v-btn>
                                    </v-toolbar>
                                </template>

                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                        title="Editar Módulo"
                                        class="mr-2"
                                        @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon
                                        title="Editar Módulo"
                                        class="mr-2"
                                        @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>

                            </v-data-table>
                            
                            <!-- Dialog de Excesso de Estoque -->
                            <v-dialog v-model="dialogCadastro" persistent max-width="400px">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text style="padding-bottom: 0;">
                                        <v-container style="padding-bottom: 0;">
                                            <v-row>
                                                <v-text-field
                                                    v-model="edited.descricao"
                                                    label="Descrição do Tipo de Evento"
                                                    outlined
                                                    :error-messages="descricaoErrors"
                                                    @input="$v.edited.descricao.$touch()"
                                                    @blur="$v.edited.descricao.$touch()"
                                                ></v-text-field>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions style="padding-top: 0;">
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="close()">Sair</v-btn>
                                        <v-btn text @click="save()">Salvar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>


import PedidoAPI from "./../../api/pedido";
import {required} from 'vuelidate/lib/validators'

export default {

    data() {
        return {

            edited:{
                descricao: ''
            },
            editedIndex: -1,

            dialogCadastro: false,
            
            headers: [
                {text: 'ID', value: 'id_tipo_evento'},
                {text: 'Tipo Evento', value: 'descricao'},
                {text: 'Ações', value: 'action', sortable: false}
            ],
            desserts: [],

        }
    },

    validations: {
        edited: {
            descricao: {
                required,
            }
        }
    },

    computed: {
        
        descricaoErrors() {
            const errors = []
            if (!this.$v.edited.descricao.$dirty) return errors
            !this.$v.edited.descricao.required && errors.push('Campo Obrigatório.')
            return errors
        },
        formTitle() {
            return this.editedIndex === -1 ? 'Novo Tipo de Evento' : 'Editar Tipo de Evento'
        },

    },

    watch: {
        
    },

    created() {

        this.buscarTiposEvento();

    },

    methods: {

        close(){
            this.dialogCadastro=false;
            this.edited = {};
        },

        editItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.edited = Object.assign({}, item)
            this.dialogCadastro = true
        },

        deleteItem(item) {

            this.edited = Object.assign({}, item)

            if (confirm('Deseja remover o Tipo de Evento?')) {

                const headers = this.Helpers.iniciarRequisicao();

                const params = this.edited;

                this.$store.dispatch("loading/addRequisicao",
                    PedidoAPI.deleteTipoEvento(headers, params)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            this.edited = {};

                            if(response.data.qtde==0){
                                this.buscarTiposEvento();
                            }else{
                                alert("Este Tipo de Evento não pode ser excluido!");
                            }

                        })
                        .catch(() => {
                            this.Helpers.logout();
                        })
                )

            }

        },

        save(){

            if (!this.$v.$invalid) {
                const headers = this.Helpers.iniciarRequisicao();

                const params = this.edited;

                this.$store.dispatch("loading/addRequisicao",
                    PedidoAPI.setTipoEvento(headers, params)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            this.buscarTiposEvento();
                            this.dialogCadastro = false;
                            this.edited = {};
                            
                        })
                        .catch(() => {
                            this.Helpers.logout();
                        })
                )
            }
        },

        buscarTiposEvento(){

            const headers = this.Helpers.iniciarRequisicao();
            
            this.$store.dispatch("loading/addRequisicao",
                PedidoAPI.getTiposEvento(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);
 
                        this.desserts = response.data.tipo_evento;
                        
                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })
            )

        },

    }
};
</script>
<style></style>
